// Layer 0 — showroom opening hours — docs/real-estate/be/
// 10-api-reference.md §A7.
import { request } from './http';

export function getOperatingHours(pid) {
  return request({ path: `/properties/${pid}/operating-hours` });
}

// `hours`: [{ day_of_week, start_time, end_time }, ...] — the whole weekly
// grid is replaced on every save.
export function setOperatingHours(pid, hours) {
  return request({
    method: 'put',
    path: `/properties/${pid}/operating-hours`,
    data: { hours },
  });
}

// Date overrides (§A7) — both times `null` means closed all day; with
// times, they replace that date's weekly hours. `body`:
// { override_date, start_time, end_time, reason } — the schema is
// additionalProperties:false, so callers must only send these fields.
export function listHoursOverrides(pid, { from_date, to_date } = {}) {
  return request({
    path: `/properties/${pid}/operating-hours/overrides`,
    params: { from_date, to_date },
  });
}

export function createHoursOverride(pid, body) {
  return request({
    method: 'post',
    path: `/properties/${pid}/operating-hours/overrides`,
    data: body,
  });
}

export function deleteHoursOverride(pid, overrideId) {
  return request({
    method: 'delete',
    path: `/properties/${pid}/operating-hours/overrides/${overrideId}`,
  });
}
